import { InjectionToken } from '@angular/core';

export type SmallWholesaleDataConfig = {
  apiPrefix: string;
};

export const SMALL_WHOLESALE_DATA_CONFIG =
  new InjectionToken<SmallWholesaleDataConfig>('SmallWholesaleDataConfig');
